import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const CountryDropdown = ({ options, onChange, selectedCountryCode }) => (
  <Select
    classNamePrefix="Select"
    classNames={{ container: () => "Select__container" }}
    onChange={e => onChange(e.value)}
    options={options}
    placeholder="Select country"
    value={options.find(o => o.value === (selectedCountryCode || "all")) || null}
    isClearable={false}
    className="main-country-dropdown"
  />
);

CountryDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
  onChange: PropTypes.func.isRequired,
  selectedCountryCode: PropTypes.string.isRequired
};

export default CountryDropdown;
